import React from "react";

const SuscripcionCard = ({ plan, price, img, handleSubscription }) => {
    return (
        <div className="plan">
            <div className="plan-title">
                <img src={img} alt="Plan Básico" />
            </div>
            <div className="plan-content"><span>{price}</span> €/año</div>
            <div className="plan-button">
                <div className="button" onClick={()=>{handleSubscription(price, plan)}}>Adquirir</div>
            </div>
        </div>
    );
}

export default SuscripcionCard;